import React, { createContext, useContext, ReactNode, useState, SetStateAction } from 'react';

export interface InAppNotificationsProvider {
  excludedChannelIds: string[];
  setExcludedChannelIds: (channelIds: SetStateAction<string[]>) => void;
}

const InAppNotificationsContext = createContext<InAppNotificationsProvider>({
  excludedChannelIds: [],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setExcludedChannelIds: (channelIds: SetStateAction<string[]>): void => {
    throw new Error('setExcludedChannelIds: SetStateAction<string[]>: void');
  },
});

export const useInAppNotificationsProvider = (): InAppNotificationsProvider =>
  useContext<InAppNotificationsProvider>(InAppNotificationsContext);

interface InAppNotificationsProviderProps {
  children: ReactNode;
}

const InAppNotificationsProvider = ({ children }: InAppNotificationsProviderProps): JSX.Element => {
  const [excludedChannelIds, setExcludedChannelIds] = useState<string[]>([]);
  return (
    <InAppNotificationsContext.Provider
      value={{
        excludedChannelIds,
        setExcludedChannelIds,
      }}
    >
      {children}
    </InAppNotificationsContext.Provider>
  );
};

export default InAppNotificationsProvider;
